import * as THREE from "three";
import store from "../state/store";

export default abstract class SpriteBase extends THREE.Sprite
{
	static spriteMaterial: THREE.SpriteMaterial | null = null;
	static spriteScale = new THREE.Vector3(0.1, 0.1, 0.1);

	static async loadSpriteMaterial(imagePath: string) : Promise<void>
	{
		if(this.spriteMaterial !== null) return;

		const spriteVisibility = store.getState()?.workspaceModule?.spritesVisible;

		this.spriteMaterial = new THREE.SpriteMaterial({
			transparent: true,
			depthTest: false,
			sizeAttenuation: false,
			visible: (spriteVisibility !== undefined) ? spriteVisibility : true
		});
		this.spriteMaterial.userData.persistent = true;
		return new Promise<void>((resolve) => 
		{
			const textureLoader = new THREE.TextureLoader();
			textureLoader.load(imagePath, (texture) => 
			{
				this.spriteMaterial!.map = texture;
				this.spriteMaterial!.needsUpdate = true;
				resolve();
			});
		});
	}
}